/**
 * Manage
 */

import {backendUrl} from '@/assets/js/config'
import axios from '@/assets/plugins/axios'
import queryString from 'querystring'
let headers = {'Content-type': 'application/x-www-form-urlencoded'}

// class ManageService {}
// export default new ManageService()

export default {
  // 获取用户列表
  queryUserList (params) {
    return axios.get(`${backendUrl}/authorization/users`, params)
  },
  // 授权/取消 用户权限
  changeUserLimit (params, query) {
    return axios.putArr(`${backendUrl}/authorization/users?` + queryString.stringify(query), params)
  },

  // 开通、取消 企业价格库编辑权限
  setPricePrivilege (params, query) {
    return axios.putArr(`${backendUrl}/authorization/gldjc_price?` + queryString.stringify(query), params)
  },

  // 操作类型
  getOperateTypes (params, workspaceId) {
    return axios.post(`${backendUrl}/${workspaceId}/logs/operate_types`, {})
  },
  // 操作列表
  getOperateList (params, workspaceId) {
    return axios.post(`${backendUrl}/${workspaceId}/logs/search`, params)
  },

  // 数据操作类型
  getDataOperateTypes (params, workspaceId) {
    return axios.post(`${backendUrl}/${workspaceId}/logs/data/operate_types`, {})
  },
  // 数据操作列表
  getDataOperateList (params, workspaceId) {
    return axios.post(`${backendUrl}/${workspaceId}/logs/data/search`, params)
  },
  // 获取分组列表
  getDepartmentList (params) {
    return axios.get(`${backendUrl}/enterprise/departments`, params)
  },
  // 新增分组
  addDepartment (params) {
    console.log(params.parentId)
    if (params.parentId){
      return axios.post(`${backendUrl}/enterprise/departments?departmentName=${params.departmentName}&parentId=${params.parentId}`)
    } else {
      return axios.post(`${backendUrl}/enterprise/departments?departmentName=${params.departmentName}`)
    }
  },
  // 编辑分组
  editDepartment (params) {
    return axios.put(`${backendUrl}/enterprise/departments?departmentId=${params.departmentId}&departmentName=${params.departmentName}`)
  },
  // 删除分组
  deleteDepartment (params) {
    return axios.delete(`${backendUrl}/enterprise/departments?departmentId=${params.departmentId}`)
  },
  // 获取企业人员列表
  getEmployeeList (params) {
    return axios.get(`${backendUrl}/enterprise/employees`, params)
  },
  // 获取企业信息后缀
  getEmployeePostfix (params) {
    return axios.get(`${backendUrl}/enterprise/employees/postfix`, params)
  },
  // 管理员首次登录设置企业后缀
  setEmployeePostfix (params) {
    return axios.post(`${backendUrl}/enterprise/employees/postfix?postfix=${params.postfix}`)
  },
  // 添加单个成员
  addEmployee (params) {
    return axios.post(`${backendUrl}/enterprise/employees?uniqueness=true&captchaId=${params.captchaId}&validate=${params.validate}&force=${params.force}`, params)
  },
  // 批量添加成员
  addBatchEmployee (options, params, hedaers) {
    return axios.postArr(`${backendUrl}/enterprise/employees/batch?uniqueness=true&captchaId=${options.captchaId}&validate=${options.validate}&departmentId=${options.departmentId}`, params, hedaers)
  },
  // 下载批量添加员工excel模板
  downloadExcelTemplate (token) {
    window.common.downloadFile(`${backendUrl}/enterprise/employees/batch?token=${token}`)
  },

  // 10.1 导出 下载文件
  download (fileName, token) {
    window.common.downloadFile(`${backendUrl}/data_manage/bill_quantity/export?fileName=${encodeURIComponent(fileName)}&token=${token}`)
  },
  // 编辑成员
  editEmployee (params) {
    return axios.put(`${backendUrl}/enterprise/employees?uniqueness=true&gldUserId=${params.gldUserId}&captchaId=${params.captchaId}&validate=${params.validate}&force=${params.force}`, params)
  },
  // 删除成员
  deleteEmployee (params) {
    return axios.delete(`${backendUrl}/enterprise/employees?gldUserId=${params.gldUserId}&deleted=${params.deleted || 0}`)
  },
  // 批量删除成员
  deleteEmployees (params){
    return axios.deleteBody(`${backendUrl}/enterprise/employees/batch`, params)
  },
  // 激活账号
  activeEmployees (params){
    return axios.put(`${backendUrl}/enterprise/activation`, params)
  },
  // 查询角色
  getRole (params) {
    return axios.postArr(`${backendUrl}/enterprise/employees/role?token=${params.token}`, params.users)
  },
  // 角色设置
  setRole (params) {
    return axios.put(`${backendUrl}/enterprise/employees/role?gldUserId=${params.gldUserId}&role=${params.role}&force=${params.force}`, params)
  },
  // 重置密码
  resetPassword (params) {
    return axios.put(`${backendUrl}/enterprise/employees/password?account=${params.account}&newPassword=${params.newPassword}`)
  },
  // 获取 已配置 和 可配置的 资产列表
  getAssetList (query, params) {
    return axios.postArr(`${backendUrl}/enterprise/assets?gldUserId=${query.gldUserId}`, params.products)
  },
  // 获取 某个资产下的 产品包
  getPackagesByAsset (params) {
    return axios.get(`${backendUrl}/enterprise/assets/product`, params)
  },
  // 通过关键词搜索有效的产品名称
  getPackagesByProductName (params) {
    return axios.get(`${backendUrl}/enterprise/assets/productnames`, params)
  },
  // 配置、取消配置 资产
  configAssetForUser (gldUserId, params) {
    return axios.put(`${backendUrl}/enterprise/assets?gldUserId=${gldUserId}`, params)
  },
  // 获取 企业现有可借出锁
  getUsbKey () {
    return axios.get(`${backendUrl}/enterprise/assets/usbKey`)
  },
  // 设置借出
  assetBorrow (gldUserId, assetIds, usbKey) {
    return axios.post(`${backendUrl}/enterprise/assets/borrow?gldUserId=${gldUserId}&assetIds=${assetIds}&usbKey=${usbKey}`)
  },
  // 管理员获取企业数据库管理信息
  managementlist () {
    return axios.get(`${backendUrl}/enterprise/cloudApplication/managementlist`)
  },
  // 管理员配置企业数据库管理权限
  setauthority (params) {
    return axios.post(`${backendUrl}/enterprise/cloudApplication/setauthority?gldUserId=${params.gldUserId}&permissionId=${params.permissionId}`)
  },
  // 设置用户的企业数据看板权限
  // setDashboardAuthority (params) {
  //   return axios.putArr(`${backendUrl}/enterprise/employees/workbench/read?gldUserId=${params.gldUserId}&readStatus=${params.readStatus}`)
  // },
  // 复制数据 到电子档案室 （已删除员工）
  copyData (params) {
    return axios.post(`${backendUrl}/data_manage/import-userdata`, params)
  },
  // 恢复账号 （已删除员工）
  restore (params) {
    return axios.post(`${backendUrl}/enterprise/employees/restore`, params, headers)
  },
  // 查询剩余可用的资产数
  assetsNumber (params) {
    return axios.get(`${backendUrl}/enterprise/assets/num`, params)
  },
  // 一键创建&自动配置资产
  createAndConfigAssets (params) {
    return axios.post(`${backendUrl}/enterprise/employees/onekey`, params, headers)
  },
  // 查询未分配的资产
  checkUnableAssets (params) {
    return axios.get(`${backendUrl}/enterprise/employees/purchase/status`, params, headers)
  },
  // 添加权限
  // addPermission (id, params) {
  //   return axios.putArr(`${backendUrl}/enterprise/employees/dbrole?gldUserId=${id}`, params)
  // },
  // 删除权限
  // deletePermission (id, params) {
  //   return axios.deleteArr(`${backendUrl}/enterprise/employees/dbrole?gldUserId=${id}`, params)
  // },
  // 获取分支地区
  getBranchAndArea () {
    return axios.get(`${backendUrl}/enterprise/branch`)
  },
  // 获取企业授信支持的组织关系类型
  getRelationTypes () {
    return axios.get(`${backendUrl}/enterprise/relation/types`)
  },
  // 生成邀请码
  getRelationApplyCode (params) {
    return axios.post(`${backendUrl}/enterprise/relation/apply_code`, params, headers)
  },
  // 验证邀请码
  checkApplyCode (params) {
    return axios.post(`${backendUrl}/enterprise/relation/apply_code/check`, params, headers)
  },
  // 创建组织关系
  createRelation (params) {
    return axios.put(`${backendUrl}/enterprise/relation/create`, params, headers)
  },
  // 解除组织关系
  unbindRelation (params) {
    return axios.post(`${backendUrl}/enterprise/relation/unbind`, params, headers)
  },
  // 查询组织关系
  getRelationList (params) {
    return axios.post(`${backendUrl}/enterprise/relation/list`, params, headers)
  },
  // 查询组织关系操作类型
  getRelationLogTypes () {
    return axios.get(`${backendUrl}/enterprise/relation/log/types`)
  },
  // 查询组织关系操作记录
  getRelationLogList (params) {
    return axios.post(`${backendUrl}/enterprise/relation/log/list`, params)
  },
  // 新增组织关系操作记录
  addRelationLog (params) {
    return axios.post(`${backendUrl}/enterprise/relation/log/add`, params)
  },
  // 获取资产管理下资产视角列表、
  postAsset (params, productName) {
    return axios.postArr(`${backendUrl}/enterprise/assets/perspective?pageNum=${params.pageNum}&pageSize=${params.pageSize}&assetAssignFlag=${params.assetAssignFlag}`, productName)
  },
  // 获取资产管理下员工视角列表、
  getStaff (params) {
    return axios.get(`${backendUrl}/enterprise/employees/perspective?pageNum=${params.pageNum}&pageSize=${params.pageSize}&keyword=${params.keyword}`)
  },
  // 批量取消分配
  unassign (params) {
    return axios.deleteBody(`${backendUrl}/enterprise/assets/batch`, params)
  },
  // 批量分配
  batchAllocation (params){
    return axios.put(`${backendUrl}/enterprise/assets/batch`, params)
  },
  // 批量移动组织
  moveRelationBatch (options, params) {
    return axios.patchArr(`${backendUrl}/enterprise/employees?uniqueness=true&captchaId=${options.captchaId}&validate=${options.validate}`, params)
  }
}
